import { ApiPathParam } from '../../../../../models/SearchParamSchema';
import { formAPIParamPath } from '../../../../../utils/StringUtils';
import { CreateCandidateFunctionRequest, FilterTypeCode, } from '../models';

export const GET_FILTER_LISTING = (typeCode: FilterTypeCode, functionParam: String) =>
    `admin/candidate/dropdown-filter/${typeCode}?functionName=${functionParam}`;
export const POST_RAW_CANDIDATE_SEARCH = (params: ApiPathParam) => {
  const tparams = formAPIParamPath(params);
  return `admin/account/candidate/search${tparams}`;
};
export const POST_CANDIDATE_CREATE_GENERATE = `admin/account/candidate`;
export const POST_CANDIDATE_CREATE_SEND_EMAIL = `admin/account/candidate/email`;
export const POST_CANDIDATE_CREATE_CHECK_EMAIL_ELIGIBILITY = `admin/account/email/check-eligibility`;
export const POST_CANDIDATE_CREATE_EXPORT_EXCEL = `admin/account/candidate/export`;
export const GET_CANDIDATE_INFO_TO_BE_UPDATED = (data: CreateCandidateFunctionRequest) =>
  `admin/candidate-info/${data.uuid}`;
export const PUT_UPDATE_AUTHENTICATION_TYPE = (data: CreateCandidateFunctionRequest) =>
  `admin/candidate-info/${data.uuid}`;
